<i18n lang="yaml">
  ru:
    ActionSidebarChatMessageTitle: "Сообщение"
    ActionSidebarChatMessageOperatorNamePlaceholder: "Имя оператора"
    ActionSidebarChatMessageMessagePlaceholder: "Сообщение призыва к действию"
    ActionSidebarChatMessageMessageValue: "Что вас интересует?"
    ActionSidebarChatMessageAddTitle: "Добавить сообщение"
  en:
    ActionSidebarChatMessageTitle: "Message"
    ActionSidebarChatMessageOperatorNamePlaceholder: "The operator name"
    ActionSidebarChatMessageMessagePlaceholder: "Message call to action"
    ActionSidebarChatMessageMessageValue: "What are you interested in?"
    ActionSidebarChatMessageAddTitle: "Add a message"
</i18n>

<template>
  <PWAsideBodyItem
    :title="$t('ActionSidebarChatMessageTitle')"
  >
    <div :class="$style.actionSidebarChatMessage">
      <PWInput
        v-model="operatorNameLocal"
        :placeholder="$t('ActionSidebarChatMessageOperatorNamePlaceholder')"
        :is-error="$v.operatorNameLocal.$error"
      >
        <template v-if="!$v.operatorNameLocal.required">
          {{ $t('requiredField') }}
        </template>
        <template v-else>
          {{ operatorNameLocal.length }} {{ $t('from') }} 30
        </template>
      </PWInput>

      <PWTextarea
        v-model="messageNumber1Local"
        :placeholder="$t('ActionSidebarChatMessageMessagePlaceholder')"
        :is-error="$v.messageNumber1Local.$error"
      >
        <template v-if="!$v.messageNumber1Local.required">
          {{ $t('requiredField') }}
        </template>
        <template v-else>
          {{ messageNumber1Local.length }} {{ $t('from') }} 100
        </template>
      </PWTextarea>

      <div>
        <button
          v-if="messageNumber2Local === null"
          :class="$style.actionSidebarChatMessageButton"
          @click="messageNumber2Local = $t('ActionSidebarChatMessageMessageValue')"
        >
          <AddRounded
            :class="$style.actionSidebarChatMessageButtonIcon"
          />
          <span :class="$style.actionSidebarChatMessageButtonLabel">
            {{ $t('ActionSidebarChatMessageAddTitle') }}
          </span>
        </button>

        <div
          v-else
          :class="$style.actionSidebarChatMessageTitleGroup"
        >
          <PWInput
            v-model="messageNumber2Local"
            :placeholder="$t('ActionSidebarChatMessageMessagePlaceholder') + ' #2'"
            :is-error="$v.messageNumber2Local.$error"
          >
            <template v-if="!$v.messageNumber2Local.required">
              {{ $t('requiredField') }}
            </template>
            <template v-else>
              {{ messageNumber2Local.length }} {{ $t('from') }} 100
            </template>
          </PWInput>

          <div>
            <button
              :class="$style.actionSidebarChatMessageRemoveTitle"
              @click="messageNumber2Local = null"
            >
              <CloseRounded :class="$style.actionSidebarChatMessageRemoveTitleIcon" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </PWAsideBodyItem>
</template>

<script>
/**
 * Utils
 */
import required from 'vuelidate/lib/validators/required'
import maxLength from 'vuelidate/lib/validators/maxLength'
/**
 * UI
 */
import PWAsideBodyItem from '@/components/_ui/Sidebars/PWAsideBodyItem.vue'
import PWInput from '@/components/_ui/PWInput.vue'
import PWTextarea from '@/components/_ui/PWTextarea.vue'
/**
 * Static
 */
import AddRounded from '@/assets/icons/AddRounded.svg?inline'
import CloseRounded from '@/assets/icons/CloseRounded.svg?inline'

export default {
  components: {
    PWAsideBodyItem,
    AddRounded,
    PWInput,
    PWTextarea,
    CloseRounded
  },
  validations () {
    return {
      operatorNameLocal: {
        required,
        maxLengthValue: maxLength(30)
      },
      messageNumber1Local: {
        required,
        maxLengthValue: maxLength(100)
      },
      messageNumber2Local: {
        required,
        maxLengthValue: maxLength(100)
      }
    }
  },
  props: {
    operatorName: {
      type: String,
      default: ''
    },
    messageNumber1: {
      type: String,
      default: ''
    },
    messageNumber2: {
      type: String,
      default: ''
    }
  },
  computed: {
    operatorNameLocal: {
      get () { return this.operatorName },
      async set (val) {
        this.$emit('update-operatorName', val)
        await this.$v.$touch()
        this.checkForError()
      }
    },
    messageNumber1Local: {
      get () { return this.messageNumber1 },
      async set (val) {
        this.$emit('update-messageNumber1', val)
        await this.$v.$touch()
        this.checkForError()
      }
    },
    messageNumber2Local: {
      get () { return this.messageNumber2 },
      async set (val) {
        this.$emit('update-messageNumber2', val)
        await this.$v.$touch()
        this.checkForError()
      }
    }
  },
  methods: {
    checkForError () {
      this.$emit('handle-validation',
        this.messageNumber2Local === null
          ? this.$v.operatorNameLocal.$error || this.$v.messageNumber1Local.$error
          : this.$v.$error
      )
    }
  }
}
</script>

<style module lang="scss">
@use '@/assets/scss/mixins';

.actionSidebarChatMessage {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.actionSidebarChatMessageButton {
  all: unset;
  display: inline-flex;
  color: var(--main-blue);
  gap: 8px;
  align-items: center;
  cursor: pointer;
}

.actionSidebarChatMessageButtonIcon {
  --s: 20px;

  width: var(--s);
  height: var(--s);
}

.actionSidebarChatMessageButtonLabel {
  color: currentColor;
  user-select: none;

  @include mixins.body2;
}

.actionSidebarChatMessageRemoveTitle {
  all: unset;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  color: var(--grey-400);
  flex-shrink: 0;
  margin-top: 18px;
}

.actionSidebarChatMessageRemoveTitleIcon {
  --s: 20px;

  width: var(--s);
  height: var(--s);
}

.actionSidebarChatMessageTitleGroup {
  display: flex;
  gap: 8px;
}
</style>
